import script from "./RequiredChangePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequiredChangePassword.vue?vue&type=script&setup=true&lang=ts"

import "./RequiredChangePassword.vue?vue&type=style&index=0&id=dc2dbd28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc2dbd28"]])

export default __exports__